import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ResultDisplay from 'components/resultDisplay/ResultDisplay';
import linkExpiredImg from 'assets/images/link_expired.png';
import {buildLoginPath } from 'utils/pathBuilder';
import './EmailLinkExpiredWithSignUp.scss';

const EmailLinkExpiredWithSignUp: React.FC = () => {
  const { t } = useTranslation('email_link_expired_with_sign_up');
  const navigate = useNavigate();

  const handleSignUp = () => {
    navigate(buildLoginPath());
  };

  return (
    <ResultDisplay
      title={t('title')}
      imageUrl={linkExpiredImg}
      onNext={handleSignUp}
      nextText={t('signUpButton')}
      showFooter={true}
    >
      <div className="email-link-expired-with-sign-up-message">
        <div>{t('message')}</div>
      </div>
    </ResultDisplay>
  );
};

export default EmailLinkExpiredWithSignUp;

